import React, { useEffect, useState } from 'react';
import { Box, Button, Grid, Group} from '@mantine/core';
import axios from 'axios';
import ApiLinks from '../../Navlinks/ApiLinks';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import CustomMantineTable from '../../Utilities/CustomMantineTable';
import { DeleteRecords, EditRecord } from '../../Utilities/EditorDeleteRecords';


function City() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);


  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/${ApiLinks.City_list}/${user.compcode}/0`)
      .then((response) => {
        if (response.data.status) {
          setData(response.data.data);
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      })
      .finally(() => {
        setLoading(false);
      });

  }, [user.compcode]);



  const columns = [
    {
      id: 'actions',
      header: 'Actions',
      size: '100',
      Cell: ({ row }) => (
        <Group spacing="xs">
          <EditRecord
            id={row.original.cityid}
            route="/dashboard/cityadd"
          />
          <DeleteRecords
            id={row.original.cityid}
            endpoint={`${ApiLinks.City_Delete}`}
            compcode={user.compcode}
            onDeleteSuccess={(deletedId) =>
              setData((prev) => prev.filter((item) => item.cityid !== deletedId))
            }
          />
        </Group>
      ),
    },
    {
      accessorKey: 'statename',
      header: 'State Name',
    },
    {
      accessorKey: 'cityname',
      header: 'City Name',
    }

  ];

  return (
    <Box>
       

      <Group position="apart" mb="md">
        <h2>City List</h2>
        <Button onClick={() => navigate('/dashboard/cityadd', { state: { id: null } })}>
          Create
        </Button>
      </Group>
      <Grid justify="center"> 
        <Grid.Col span={6}>
          <CustomMantineTable columns={columns} data={data} loading={loading} />
        </Grid.Col>
      </Grid>
    </Box>

  );
}

export default City;
